import Dexie from 'dexie';
import {
  SotGa4BatchTypeValue,
  SotGa4Row
} from '../Pages/SotGa4MappingTool/sot-ga4-mapping-tool-constants';

export interface SotGa4EditRecord {
  cid: string;
  campaignKey: string;
  batchType: SotGa4BatchTypeValue;
  rowData: SotGa4Row;
  timestamp: number;
}

export type SotGa4EditRecordKey = [string, string, SotGa4BatchTypeValue];

export class DexieDBSotGa4 extends Dexie {
  editRecords!: Dexie.Table<SotGa4EditRecord, SotGa4EditRecordKey>;

  constructor() {
    super('DexieDBSotGa4');
    this.version(1).stores({
      editRecords: '++id, cid, campaignKey, batchType, rowData, timestamp'
    });
    this.version(2).stores({
      editRecords: null
    });
    this.version(3).stores({
      editRecords: '[cid+campaignKey+batchType], cid, [cid+batchType], timestamp'
    });
  }
}

export const dbSotGa4 = new DexieDBSotGa4();
